'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { FilterDrawerShell } from '../FilterDrawerShell';
import { FilterSection } from '../FilterSection';
import { FilterSidebarShell } from '../FilterSidebarShell';
import { RegionFilterDialog, RegionFilterField } from '../RegionFilterField';
interface HometownNewsFilterProps {
  isDrawerOpen: boolean;
  onCloseDrawer: () => void;
  onApplyDrawer: () => void;
  regionCode: string | null;
  subRegionCode: string | null;
  onRegionChange: (code: string | null) => void;
  onSubRegionChange: (code: string | null) => void;
  onReset: () => void;
}
const REGION_DIALOG_TITLE = '동네소식을 볼 지역을 선택해 주세요';
export function HometownNewsFilter(t0) {
  const $ = _c(32);
  const {
    isDrawerOpen,
    onCloseDrawer,
    onApplyDrawer,
    regionCode,
    subRegionCode,
    onRegionChange,
    onSubRegionChange,
    onReset
  } = t0;
  const [isRegionDialogOpened, setIsRegionDialogOpened] = useState(false);
  let t1;
  if ($[0] !== onRegionChange || $[1] !== onSubRegionChange || $[2] !== regionCode || $[3] !== subRegionCode) {
    t1 = <FilterSection title={"\uC9C0\uC5ED"}><RegionFilterField regionCode={regionCode} subRegionCode={subRegionCode} onRegionChange={onRegionChange} onSubRegionChange={onSubRegionChange} title={REGION_DIALOG_TITLE} /></FilterSection>;
    $[0] = onRegionChange;
    $[1] = onSubRegionChange;
    $[2] = regionCode;
    $[3] = subRegionCode;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== onReset || $[6] !== t1) {
    t2 = <FilterSidebarShell onReset={onReset}>{t1}</FilterSidebarShell>;
    $[5] = onReset;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h3 className="font-700 text-Gray-900 typo-body4">지역</h3>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isRegionDialogOpened || $[10] !== onRegionChange || $[11] !== onSubRegionChange || $[12] !== regionCode || $[13] !== subRegionCode) {
    t4 = <div className="flex flex-col gap-12">{t3}<RegionFilterField regionCode={regionCode} subRegionCode={subRegionCode} onRegionChange={onRegionChange} onSubRegionChange={onSubRegionChange} title={REGION_DIALOG_TITLE} dialogOpened={isRegionDialogOpened} onDialogOpenChange={setIsRegionDialogOpened} renderDialog={false} /></div>;
    $[9] = isRegionDialogOpened;
    $[10] = onRegionChange;
    $[11] = onSubRegionChange;
    $[12] = regionCode;
    $[13] = subRegionCode;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== isDrawerOpen || $[16] !== onApplyDrawer || $[17] !== onCloseDrawer || $[18] !== onReset || $[19] !== t4) {
    t5 = <FilterDrawerShell isOpen={isDrawerOpen} onReset={onReset} onApply={onApplyDrawer} onClose={onCloseDrawer}>{t4}</FilterDrawerShell>;
    $[15] = isDrawerOpen;
    $[16] = onApplyDrawer;
    $[17] = onCloseDrawer;
    $[18] = onReset;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsRegionDialogOpened(false);
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== isRegionDialogOpened || $[23] !== onRegionChange || $[24] !== onSubRegionChange || $[25] !== regionCode || $[26] !== subRegionCode) {
    t7 = <RegionFilterDialog opened={isRegionDialogOpened} onClose={t6} regionCode={regionCode} subRegionCode={subRegionCode} onRegionChange={onRegionChange} onSubRegionChange={onSubRegionChange} title={REGION_DIALOG_TITLE} />;
    $[22] = isRegionDialogOpened;
    $[23] = onRegionChange;
    $[24] = onSubRegionChange;
    $[25] = regionCode;
    $[26] = subRegionCode;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t2 || $[29] !== t5 || $[30] !== t7) {
    t8 = <>{t2}{t5}{t7}</>;
    $[28] = t2;
    $[29] = t5;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  return t8;
}